import FAQs from "@/pages/faqs";
import { createPublicSsrPage } from "../../src/vike/createPublicSsrPage";
import { PATHS } from "../../src/shared/publicPaths";

export default createPublicSsrPage({
  pathname: PATHS.faq,
  overrideKey: "faqa",
  element: <FAQs />,
});
